var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('v-app',[_c('v-row',{staticStyle:{"margin":"0 !important"}},[(!_vm.isLoginPage)?_c('sidebar-component'):_vm._e(),_c('v-main',{staticClass:"background-container3",class:_vm.isProfilePage},[_c('router-view')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }